import AdminLayout from "./AdminLayout";

const DashboardInnerPage = () => {
  return (
    <AdminLayout>
      <div className="dashboard_page_wepper">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="total_sale_box">
                <div className="total_sale_box_inner">
                  <div className="total_sale_img_data">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.8372 28.5493L24.7958 20.5893L26.7398 25.536L10.2865 32L3.87584 15.6827L16.8372 28.5493ZM15.1358 0H2.6665V12.604L16.8332 26.6667L29.3332 14.1667L15.1358 0ZM20.5025 12.6347C19.9492 12.0813 19.3492 11.812 18.6652 11.812C17.8945 11.812 17.0292 12.1333 15.7705 12.884C14.8612 13.4307 14.2798 13.6627 13.8292 13.6627C13.3478 13.6627 12.3852 13.1187 12.5478 12.0387C12.6172 11.5787 12.8812 11.1093 13.3105 10.6787C14.1798 9.81067 15.3692 9.548 16.3452 10.5373L17.3372 9.54533C16.7025 8.91067 15.8758 8.48933 14.9892 8.48933C14.2345 8.48933 13.4892 8.792 12.7718 9.392L11.9372 8.556L11.0065 9.488L11.8772 10.3573C11.1185 11.4587 10.7545 13.052 11.9785 14.2747C13.3265 15.6227 14.8958 14.996 16.5292 13.9653C17.3292 13.46 17.9732 13.2147 18.4958 13.2147C19.2812 13.2147 20.0692 13.8787 19.9332 14.892C19.8638 15.4067 19.5865 15.9093 19.1052 16.388C18.5038 16.9893 17.8998 17.2933 17.3092 17.2933C16.7518 17.2933 16.3132 17.0373 15.9105 16.6773L14.9252 17.6627C15.5425 18.2733 16.3678 18.6667 17.2385 18.6667C17.9638 18.6667 18.6878 18.3987 19.3878 17.8707L20.1078 18.588L21.0372 17.6587L20.3438 16.964C21.3345 15.7693 21.8865 14.0187 20.5025 12.6347ZM7.5985 2.66667C8.84917 2.66667 9.86384 3.68133 9.86384 4.932C9.86384 6.18267 8.84917 7.19733 7.5985 7.19733C6.34784 7.19733 5.33317 6.18267 5.33317 4.932C5.33317 3.68133 6.34784 2.66667 7.5985 2.66667Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="total_content">
                    <h3>Total Products</h3>
                    <p>280</p>
                    <div className="arow_trind">
                      <svg
                        width="16"
                        height="12"
                        viewBox="0 0 16 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.479 0.75L10.979 1.66575L12.266 2.94675L8.25275 6.96525L6.002 4.71375L0.5 10.1453L1.5575 11.2087L5.999 6.83325L8.24225 9.078L13.328 4.0065L14.5782 5.2515L15.479 0.75Z"
                          fill="#128C7F"
                        />
                      </svg>
                      <p>55%</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="total_sale_box">
                <div className="total_sale_box_inner">
                  <div className="total_sale_img_data today_user_bg">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.33333 25.3335H1.33333V10.6668H9.33333V25.3335ZM20 1.3335H12V25.3335H20V1.3335ZM30.6667 16.0002H22.6667V25.3335H30.6667V16.0002ZM32 28.0002H0V30.6668H32V28.0002Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="total_content">
                    <h3>COD Orders</h3>
                    <p>2000</p>
                    <div className="arow_trind">
                      <svg
                        width="16"
                        height="12"
                        viewBox="0 0 16 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.479 0.75L10.979 1.66575L12.266 2.94675L8.25275 6.96525L6.002 4.71375L0.5 10.1453L1.5575 11.2087L5.999 6.83325L8.24225 9.078L13.328 4.0065L14.5782 5.2515L15.479 0.75Z"
                          fill="#128C7F"
                        />
                      </svg>
                      <p>8%</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="total_sale_box">
                <div className="total_sale_box_inner">
                  <div className="total_sale_img_data revenue_bg">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.3333 12V10.536L14.7293 4H17.2693L18.6667 10.5333V11.9973C18.6667 13.42 17.4227 14.6667 16 14.6667C14.5773 14.6667 13.3333 13.4227 13.3333 12ZM20 12C20 13.4227 21.2453 14.6667 22.668 14.6667C24.0907 14.6667 25.3333 13.556 25.3333 12.1333V10.6693L21.3387 4H18.748L20 10.536V12ZM6.66667 12.0907C6.66667 13.5133 7.91067 14.6667 9.33333 14.6667C10.756 14.6667 12 13.5133 12 12.0907V10.628L13.252 4H10.6613L6.66667 10.628V12.0907ZM1.33333 16H30.6667V32H1.33333V16ZM4 26.6667H28V18.6667H4V26.6667ZM5.33333 12.0907V10.628L9.18267 4H6.49733L0 10.628V12.092C0 13.5133 1.244 14.6667 2.66667 14.6667C4.08933 14.6667 5.33333 13.5133 5.33333 12.0907ZM25.5027 4H22.8173L26.6667 10.536V12C26.6667 13.4227 27.9107 14.6667 29.3333 14.6667C30.756 14.6667 32 13.5133 32 12.0907V10.628L25.5027 4ZM25.3333 0H6.66667V2.66667H25.3333V0Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="total_content">
                    <h3>Pending Orders</h3>
                    <p>35k</p>
                    <div className="arow_trind">
                      <svg
                        width="16"
                        height="12"
                        viewBox="0 0 16 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.479 0.75L10.979 1.66575L12.266 2.94675L8.25275 6.96525L6.002 4.71375L0.5 10.1453L1.5575 11.2087L5.999 6.83325L8.24225 9.078L13.328 4.0065L14.5782 5.2515L15.479 0.75Z"
                          fill="#128C7F"
                        />
                      </svg>
                      <p>2%</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3">
              <div className="total_sale_box">
                <div className="total_sale_box_inner">
                  <div className="total_sale_img_data customers_bg">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M26 20C22.6893 20 20 22.6867 20 26C20 29.3133 22.6893 32 26 32C29.3107 32 32 29.3133 32 26C32 22.6867 29.3107 20 26 20ZM29.3333 26.6667H26.6667V29.3333H25.3333V26.6667H22.6667V25.3333H25.3333V22.6667H26.6667V25.3333H29.3333V26.6667ZM19.76 32H0.00666667L0 30.3453C0 26.9853 0.265333 25.0453 4.23733 24.128C8.724 23.092 13.1547 22.164 11.024 18.2373C4.71333 6.59867 9.224 0 16 0C25.0013 0 26.008 10.1267 20.8533 18.2387C19.1307 20.9467 17.3333 23.0787 17.3333 26C17.3333 28.3293 18.2613 30.4413 19.76 32Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="total_content">
                    <h3> Shipped orders</h3>
                    <p>1800</p>
                    <div className="arow_trind">
                      <svg
                        width="16"
                        height="12"
                        viewBox="0 0 16 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.479 0.75L10.979 1.66575L12.266 2.94675L8.25275 6.96525L6.002 4.71375L0.5 10.1453L1.5575 11.2087L5.999 6.83325L8.24225 9.078L13.328 4.0065L14.5782 5.2515L15.479 0.75Z"
                          fill="#128C7F"
                        />
                      </svg>
                      <p>35%</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="sales_sec_wepper">
          <div className="container">
            <div className="row">
              {/* sales Chart */}
              <div className="col-lg-8">
                <div className="sales_sec">
                  <div className="sales_hedding">
                    <p>
                      <strong>
                        Sales
                        <svg
                          width="16"
                          height="15"
                          viewBox="0 0 16 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.76477 4.99746V7.50012M7.76477 10.0028H7.77103M13.3957 7.50012C13.3957 8.23959 13.2501 8.97182 12.9671 9.655C12.6841 10.3382 12.2694 10.9589 11.7465 11.4818C11.2236 12.0047 10.6028 12.4195 9.91965 12.7025C9.23647 12.9854 8.50424 13.1311 7.76477 13.1311C7.0253 13.1311 6.29307 12.9854 5.60989 12.7025C4.9267 12.4195 4.30595 12.0047 3.78306 11.4818C3.26018 10.9589 2.8454 10.3382 2.56242 9.655C2.27944 8.97182 2.13379 8.23959 2.13379 7.50012C2.13379 6.00669 2.72705 4.57443 3.78306 3.51842C4.83908 2.4624 6.27134 1.86914 7.76477 1.86914C9.2582 1.86914 10.6905 2.4624 11.7465 3.51842C12.8025 4.57443 13.3957 6.00669 13.3957 7.50012Z"
                            stroke="#9CA3AF"
                            strokeWidth="1.25133"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </strong>
                    </p>
                    <select name="cars" id="cars">
                      <option value="Month">Month</option>
                      <option value="saab">Saab</option>
                      <option value="opel">Opel</option>
                      <option value="audi">Audi</option>
                    </select>
                  </div>
                  <div className="sales_rating">
                    <p>240K</p>
                    <div className="divider_only"></div>
                  </div>
                  <div className="sales_rating">
                    <p>200K</p>
                    <div className="divider_only"></div>
                  </div>
                  <div className="sales_rating">
                    <p>160K</p>
                    <div className="divider_only"></div>
                  </div>

                  <div className="sales_rating">
                    <p>120K</p>
                    <div className="divider_only"></div>
                  </div>
                  <div className="sales_rating garaf_line_wepper dashboard_garaf_line_wepper">
                    <p>80K</p>
                    <div className="divider_only"></div>
                    <div className="garaf_line_img">
                      <svg
                        width="728"
                        height="240"
                        viewBox="0 0 728 240"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M248.006 1.12513V239.56"
                          stroke="#E5E7EB"
                          stroke-width="0.625664"
                          stroke-linecap="square"
                          stroke-dasharray="3.13 3.13"
                        />
                        <path
                          d="M1.18115 149.65C1.18115 149.65 32.5023 130.072 52.0781 130.072C71.6538 130.072 84.3781 136.598 104.443 136.598C124.508 136.598 136.254 126.809 155.83 126.809C175.405 126.809 188.129 143.124 208.195 143.124C228.26 143.124 240.005 154.545 259.581 154.545C279.157 154.545 291.881 121.915 311.946 121.915C332.011 121.915 343.757 141.493 363.332 141.493C382.908 141.493 395.632 131.704 415.698 131.704C435.763 131.704 448.487 151.282 468.063 151.282C487.638 151.282 499.873 118.652 519.449 118.652C539.025 118.652 552.238 133.335 571.814 133.335C591.39 133.335 603.625 113.758 623.2 113.758C642.776 113.758 655.99 131.704 675.566 131.704C695.141 131.704 726.952 90.1011 726.952 90.1011"
                          stroke="#0E9F6E"
                          stroke-width="1.87699"
                        />
                        <g filter="url(#filter0_d_507_53568)">
                          <rect
                            x="244.564"
                            y="149.633"
                            width="6.25664"
                            height="6.25664"
                            rx="3.12832"
                            fill="#0E9F6E"
                          />
                          <rect
                            x="245.19"
                            y="150.259"
                            width="5.00531"
                            height="5.00531"
                            rx="2.50266"
                            stroke="white"
                            stroke-width="1.25133"
                          />
                        </g>
                        <defs>
                          <filter
                            id="filter0_d_507_53568"
                            x="242.062"
                            y="148.382"
                            width="11.2622"
                            height="11.2622"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dy="1.25133" />
                            <feGaussianBlur stdDeviation="1.25133" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.268354 0 0 0 0 0.268354 0 0 0 0 0.31049 0 0 0 0.15 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_507_53568"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_507_53568"
                              result="shape"
                            />
                          </filter>
                        </defs>
                      </svg>

                      <div className="date_show_wepper">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="97"
                          height="63"
                          viewBox="0 0 97 63"
                          fill="none"
                        >
                          <g filter="url(#filter0_dd_507_53572)">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M48.8271 59.0851C47.5716 60.6291 45.536 60.6291 44.2806 59.0851L42.1605 56.8427C41.5696 56.2176 40.7474 55.8635 39.8873 55.8635H14.5248C10.1336 55.8635 8.5413 55.4279 6.93597 54.61C5.33064 53.792 4.07077 52.5917 3.21223 51.0623C2.35369 49.5329 1.89648 48.0159 1.89648 43.8325V13.4617C1.89648 9.27822 2.35369 7.7612 3.21223 6.2318C4.07077 4.7024 5.33064 3.50211 6.93597 2.68418C8.5413 1.86625 10.1336 1.43066 14.5248 1.43066L81.8665 1.43066C86.2577 1.43066 87.85 1.86625 89.4553 2.68418C91.0607 3.50211 92.3205 4.7024 93.1791 6.2318C94.0376 7.7612 94.4948 9.27822 94.4948 13.4617V43.8325C94.4948 48.0159 94.0376 49.5329 93.1791 51.0623C92.3205 52.5917 91.0607 53.792 89.4553 54.61C87.85 55.4279 86.2577 55.8635 81.8665 55.8635H54.5679C52.8476 55.8635 51.2032 56.5718 50.0214 57.8219L48.8271 59.0851Z"
                              fill="white"
                            />
                          </g>
                          <defs>
                            <filter
                              id="filter0_dd_507_53572"
                              x="0.0194913"
                              y="0.179335"
                              width="96.3521"
                              height="62.5665"
                              filterUnits="userSpaceOnUse"
                              color-interpolation-filters="sRGB"
                            >
                              <feFlood
                                flood-opacity="0"
                                result="BackgroundImageFix"
                              />
                              <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                              />
                              <feOffset dy="0.625664" />
                              <feGaussianBlur stdDeviation="0.938497" />
                              <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                              />
                              <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_507_53572"
                              />
                              <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                              />
                              <feOffset dy="0.625664" />
                              <feGaussianBlur stdDeviation="0.625664" />
                              <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                              />
                              <feBlend
                                mode="normal"
                                in2="effect1_dropShadow_507_53572"
                                result="effect2_dropShadow_507_53572"
                              />
                              <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect2_dropShadow_507_53572"
                                result="shape"
                              />
                            </filter>
                          </defs>
                        </svg>
                        <div className="garf_price_dasbord">
                          <span>29 Nov, 2024</span>
                          <p>
                            Sales: <strong>₹79k</strong>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="sales_rating">
                    <p>40K</p>
                    <div className="divider_only"></div>
                  </div>
                  <div className="sales_rating">
                    <p>0K</p>
                    <div className="divider_only"></div>
                  </div>

                  <div className="month_data_weper">
                    <div className="month_inner">
                      <p>01 Apr</p>
                    </div>
                    <div className="month_inner">
                      <p>02 Apr</p>
                    </div>
                    <div className="month_inner">
                      <p>03 Apr</p>
                    </div>
                    <div className="month_inner">
                      <p>04 Apr</p>
                    </div>
                    <div className="month_inner">
                      <p>05 Apr</p>
                    </div>
                    <div className="month_inner">
                      <p>06 Apr</p>
                    </div>
                    <div className="month_inner">
                      <p>07 Apr</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* transaction */}
              <div className="col-lg-4">
                <div className="transactions_wepper">
                  <div className="transaction_hedding_wepper">
                    <h3>Transactions</h3>
                    <p>
                      <img src="images/dot-icon.svg" alt="" />
                    </p>
                  </div>

                  <div className="row">
                    <div className="col-lg-6">
                      <div className="total_sale_box_inner transactions_wepper_main">
                        <div className="total_sale_img_data">
                          <img src="images/ion_wallet.png" alt="" />
                        </div>
                        <div className="total_content">
                          <p>Wallet</p>
                          <h5>Designer</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="transaction_price">
                        <span>+70.20 ₹</span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6">
                      <div className="total_sale_box_inner transactions_wepper_main">
                        <div className="total_sale_img_data">
                          <img src="images/ion_wallet.png" alt="" />
                        </div>
                        <div className="total_content">
                          <p>Wallet</p>
                          <h5>Designer</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="transaction_price">
                        <span>+70.20 ₹</span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="total_sale_box_inner transactions_wepper_main">
                        <div className="total_sale_img_data">
                          <img src="images/ion_wallet.png" alt="" />
                        </div>
                        <div className="total_content">
                          <p>Wallet</p>
                          <h5>Designer</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="transaction_price">
                        <span>+70.20 ₹</span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="total_sale_box_inner transactions_wepper_main">
                        <div className="total_sale_img_data">
                          <img src="images/ion_wallet.png" alt="" />
                        </div>
                        <div className="total_content">
                          <p>Wallet</p>
                          <h5>Designer</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="transaction_price">
                        <span>+70.20 ₹</span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="total_sale_box_inner transactions_wepper_main">
                        <div className="total_sale_img_data">
                          <img src="images/ion_wallet.png" alt="" />
                        </div>
                        <div className="total_content">
                          <p>Wallet</p>
                          <h5>Designer</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="transaction_price">
                        <span>+70.20 ₹</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* sales by state */}
        <div className="sale_by_states_wepper">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="sales_sec">
                  <div className="sales_hedding">
                    <p>
                      <strong>Sale by States</strong>
                    </p>
                    <div className="divider_only"></div>
                    <div className="row mt-4 justify-content-center">
                      <div className="col-lg-1">
                        <div className="golob_img">
                          <img src="images/globe.png" alt="" />
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding">
                          <h3>Country</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding">
                          <h3>Customer</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding">
                          <h3>Sale</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding">
                          <h3>Value</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding">
                          <h3>Bounce</h3>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-4 justify-content-center">
                      <div className="col-lg-1">
                        <div className="golob_img">
                          <img src="images/flag.png" alt="" />
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>jaipur</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>1200</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>1400</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>₹190,700</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>23.44%</h3>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-4 justify-content-center">
                      <div className="col-lg-1">
                        <div className="golob_img">
                          <img src="images/flag.png" alt="" />
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>jaipur</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>1200</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>1400</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>₹190,700</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>23.44%</h3>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-4 justify-content-center">
                      <div className="col-lg-1">
                        <div className="golob_img">
                          <img src="images/flag.png" alt="" />
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>jaipur</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>1200</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>1400</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>₹190,700</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>23.44%</h3>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-4 justify-content-center">
                      <div className="col-lg-1">
                        <div className="golob_img">
                          <img src="images/flag.png" alt="" />
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>jaipur</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>1200</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>1400</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>₹190,700</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>23.44%</h3>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-4 justify-content-center">
                      <div className="col-lg-1">
                        <div className="golob_img">
                          <img src="images/flag.png" alt="" />
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>jaipur</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>1200</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>1400</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>₹190,700</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>23.44%</h3>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-4 justify-content-center">
                      <div className="col-lg-1">
                        <div className="golob_img">
                          <img src="images/flag.png" alt="" />
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>jaipur</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>1200</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>1400</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>₹190,700</h3>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="golob_hedding_inner">
                          <h3>23.44%</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="growth_wepper">
                  <div className="sales_hedding">
                    <p>
                      <strong>
                        Sales
                        <svg
                          width="16"
                          height="15"
                          viewBox="0 0 16 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.76477 4.99746V7.50012M7.76477 10.0028H7.77103M13.3957 7.50012C13.3957 8.23959 13.2501 8.97182 12.9671 9.655C12.6841 10.3382 12.2694 10.9589 11.7465 11.4818C11.2236 12.0047 10.6028 12.4195 9.91965 12.7025C9.23647 12.9854 8.50424 13.1311 7.76477 13.1311C7.0253 13.1311 6.29307 12.9854 5.60989 12.7025C4.9267 12.4195 4.30595 12.0047 3.78306 11.4818C3.26018 10.9589 2.8454 10.3382 2.56242 9.655C2.27944 8.97182 2.13379 8.23959 2.13379 7.50012C2.13379 6.00669 2.72705 4.57443 3.78306 3.51842C4.83908 2.4624 6.27134 1.86914 7.76477 1.86914C9.2582 1.86914 10.6905 2.4624 11.7465 3.51842C12.8025 4.57443 13.3957 6.00669 13.3957 7.50012Z"
                            stroke="#9CA3AF"
                            strokeWidth="1.25133"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </strong>
                    </p>
                    <select name="cars" id="cars">
                      <option value="Month">Month</option>
                      <option value="saab">Saab</option>
                      <option value="opel">Opel</option>
                      <option value="audi">Audi</option>
                    </select>
                  </div>

                  <div className="growth_img">
                    <img src="images/growth.png" alt="" />
                  </div>
                </div>
                <div className="growth_wepper">
                  <div className="sales_hedding">
                    <p>
                      <strong>Earning</strong>
                    </p>
                    <div className="earning_img">
                      <svg
                        width="16"
                        height="12"
                        viewBox="0 0 16 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.479 0.75L10.979 1.66575L12.266 2.94675L8.25275 6.96525L6.002 4.71375L0.5 10.1453L1.5575 11.2087L5.999 6.83325L8.24225 9.078L13.328 4.0065L14.5782 5.2515L15.479 0.75Z"
                          fill="#fff"
                        ></path>
                      </svg>
                    </div>
                  </div>

                  <div className="growth_price_wepper">
                    <h3>₹89,670</h3>
                    <span>+28.8%</span>
                    <p>This month growth</p>
                    <a>Withdraw money</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default DashboardInnerPage;
